// extracted by mini-css-extract-plugin
module.exports = {"container":"d_kdkOg"};